import { useMutation, useQueryClient } from '@tanstack/react-query'

import { createItemCategory } from '@flecto/api/saas'
import { type CoreItemCategoryPayload } from '@flecto/types'

type MutationPayload = {
  category: CoreItemCategoryPayload
}

export function useMutationCreateItemCategory() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['MutationCreateItemCategory'],
    mutationFn: async ({ category }: MutationPayload) =>
      await createItemCategory(category),
    onSuccess: (category) => {
      queryClient.invalidateQueries(['QueryGetAllItemCategoriesV2'])

      if (category.parent_id) {
        queryClient.invalidateQueries([
          'useQueryGetItemCategory',
          category.parent_id,
        ])
      }
    },
  })
}
